import useLocaleLink from 'hooks/useLocaleLink';
import type { CategoryNavItem } from 'types/help-center';

interface CategorySidebarProps {
  categories: CategoryNavItem[];
  activeSlug: string;
}

export default function CategorySidebar({ categories, activeSlug }: CategorySidebarProps) {
  const localeLink = useLocaleLink();

  return (
    <nav className="hidden shrink-0 flex-col items-center self-stretch border-r border-base-line-primary pb-4 pr-6 pt-6 pad:flex">
      <ul className="flex w-[228px] flex-col gap-3">
        {categories.map((cat) => {
          const isActive = cat.slug === activeSlug;
          return (
            <li key={cat.slug}>
              <a
                href={`${localeLink}${cat.href}`}
                className={`flex w-[228px] items-center rounded-lg px-4 py-3 text-md leading-6 text-base-label transition-colors hover:bg-base-fill-secondary hover:text-base-primary ${
                  isActive ? 'bg-base-fill-secondary font-medium' : ''
                }`}
              >
                {cat.title}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
